<template>
  <v-container fluid grid-list-md py1 class="custom adjuntos_talento">
    <div>
      <file-pond
        ref="pond"
        :max-files="maxfiles"
        name="file"
        allow-process="false"
        instant-upload="false"
        allow-revert="false"
        allow-paste="false"
        max-parallel-uploads="1"
        :label-file-loading="$t('view.commons.filepond.labelFileLoading')"
        :label-file-processing="$t('view.commons.filepond.labelFileProcessing')"
        :label-file-processing-complete="$t('view.commons.filepond.labelFileProcessingComplete')"
        :label-tap-to-retry="$t('view.commons.filepond.labelTapToRetry')"
        :label-idle="$t('view.commons.filepond.labelidle')"
        :label-invalid-field="$t('view.commons.filepond.labelInvalidField')"
        :label-file-processing-aborted="$t('view.commons.filepond.labelFileProcessingAborted')"
        :label-tap-to-cancel="$t('view.commons.filepond.labelTapToCancel')"
        :label-file-load-error="$t('view.commons.filepond.labelFileLoadError')"
        :label-file-processing-error="$t('view.commons.filepond.labelFileProcessingError')"
        :label-file-type-not-allowed="$t('view.commons.filepond.labelFileTypeNotAllowed')"
        :label-max-file-size-exceeded="$t('view.commons.filepond.labelMaxFileSizeExceeded')"
        :label-max-file-size="$t('view.commons.filepond.labelMaxFileSize')"
        :label-max-total-file-size-exceeded="$t('view.commons.filepond.labelMaxTotalFileSizeExceeded')"
        :file-validate-type-label-expected-types="$t('view.commons.filepond.fileValidateTypeLabelExpectedTypes').replace(/{(\d+)}/g, 'texto/imagen/pdf/office')"
        :label-button-download-item="$t('view.commons.filepond.labelButtonDownloadItem')"
        allow-file-size-validation="true"
        allow-multiple="false"
        allow-replace="false"
        allow-file-rename="true"
        drop-on-page="false"
        allow-download-by-url="true"
        accepted-file-types="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword"
        :files="myFiles"
        :server="{ process, revert}"
        :max-total-file-size="`${maxfilesize}MB`"
        :max-file-size="`${maxfilesize}MB`"
        :file-rename-function="rename"
        @warning="warning"
        @error="error"
        @addfile="addFileAdjuntos"
        @removefile="removeFromFilePond" />
    </div>
  </v-container>
</template>
<script>
import removeAccents from "remove-accents";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { getDateWithFormat } from "@/helpers/date-methods";

export default {
  name: "TalentoAdjuntos"
  , props: {
    talento: {
      default: undefined
      , type: Object
    }
    , maxfilesize: {
      default: 0
      , type: Number
    }
  }
  , data() {
    return { myFiles: [], maxfiles: "1" };
  }
  , methods: {
    process(_fieldName, file, _metadata, load, error, progress, abort) {
      try {
        // Construccion del formulario mock para request de subida de archivo
        const formData = new FormData();
        formData.append("file", file);
        formData.append("filename", file.name);

        // Construccion de request
        const request = new XMLHttpRequest();
        request.open("POST", "/api/bitacoraArchivos");
        request.setRequestHeader("Authorization", `Bearer ${this.$store.getters.getUserToken}`);
        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, e.total);
        };

        request.onload = () => {
          this.mensajeErrorArchivo = "Ocurrió un error, intente nuevamente o compruebe sus permisos";
          if (request.status >= 200 && request.status < 300) {
            // the load method accepts either a string (id) or an object
            let response = JSON.parse(request.response);
            if (response.meta.code == "OK" && response.results) {
              let adjuntos = this.talento.adjuntos;
              adjuntos += adjuntos ? "," : "";
              adjuntos += `${response.results}:${file.name}:${file.size}:${file.type}:true:${getDateWithFormat("dd-MM-yyyy+hh-mm")}`;
              this.$emit("adjuntos", adjuntos);

              file.file = response.results;
              load(response.results);
            } else {
              error(response.results.error);
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "Error al subir archivo");
            }
          } else {
            error("Ocurrió un error al subir el archivo");
          }
        };
        request.send(formData);

        // Should expose an abort method so the request can be cancelled
        return {
          abort: () => {
            request.abort();
            abort();
          }
        };
      } catch (error2) {
        console.error(error2);
      }
    }
    , validateFilesBeforeSubmit() {
      const files = this.$refs.pond.getFiles();
      const validFileTypes = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword"];
      const hasValidFile = files.some((file) => validFileTypes.includes(file.fileType));

      if (!hasValidFile) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "El CV es requerido.");
        return false;
      }
      return true;
    }
    , rename(file) {
      return removeAccents(file.name.replaceAll(" ", "_")).replace(/[^a-zA-Z_ .-@]/g, "");
    }
    , revert(uniqueFileId, load) {
      this.removeFromFilePond(uniqueFileId);
      load();
    }
    , warning(error, file) {
      if ("Max files" == error.body) error.body = this.$t("view.commons.filepond.labelMaxFiles").replace(/{(\d+)}/g, this.maxfiles);
      if (error && error.type) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, error.type, "VL0000", error.body);
      file.file.error = true;
      setTimeout(() => {
        this.$refs.pond.removeFile(file.id);
      }, 6000);
    }
    , error(error, file) {
      if ("Max files" == error.body) error.body = this.$t("view.commons.filepond.labelMaxFiles").replace(/{(\d+)}/g, this.maxfiles);
      if (error && error.type) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, error.type, "VL0000", error.body);
      file.file.error = true;
      setTimeout(() => {
        this.$refs.pond.removeFile(file.id);
      }, 6000);
    }
    , addFileAdjuntos(error, fileItem){
      this.validateName(fileItem);
      if (!error){
        this.$emit("adjuntos", " ");
      }
    }
    , validateName(fileItem){
      const filename = fileItem.file.name;
      const invalids = ["\\","/", ":", "*", "?", "\"", "<", ">", "|"];

      const charinvalid = invalids.find(char => filename.includes(char));
      
      if (charinvalid){
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "warning", "VL0000", this.$t("view.commons.filepond.fileNameInvalid").replace(/{(.+?)}/g, charinvalid));
        this.$refs.pond.removeFile(fileItem.id);
      }
    }
    , removeFromFilePond(id) {
      this.myFiles = this.removeAttachmentFromList(id, this.myFiles);
      this.$emit("adjuntos", this.myFiles ? this.aplanarList(this.myFiles) : []);
    }
    , removeAttachmentFromList(id, list) {
      const index = list.findIndex((item) => item.source.includes(id));
      return [...list.slice(0, index), ...list.slice(index + 1)];
    }
    , aplanarList(list) {
      return list
        .map((item) => {
          const { file, name, size, type, priv, date } = item.options.file;
          return `${file}:${name}:${size}:${type}:${priv}:${date}`;
        })
        .join(",");
    }
  }
};
</script>

<style>
.adjuntos_talento.custom.container {
  padding: 10px 0 0 0;
  max-width: 100% !important;
}
.adjuntos_talento .filepond--root {
  min-height: 2em !important;
  margin-bottom: 0;
  font-size: 14pt !important;
}
.adjuntos_talento .removePermission .filepond--action-remove-item {
  display: none !important;
}

.filepond--file-info .filepond--file-info-main-container {
  display: flex;
  align-items: center;
}

.adjuntos_talento .filepond--panel-root {
  background-color: #e8e6e3;
  border: 3px dashed var(--v-primary-base);
}

.adjuntos_talento .filepond--item-panel {
  background-color: var(--v-primary-base) !important;
}

.adjuntos_talento [data-filepond-item-state*="error"] .filepond--item-panel,
[data-filepond-item-state*="invalid"] .filepond--item-panel {
  background-color: #c44e47 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/talento/TalentoAdjuntos.vue